import { render, staticRenderFns } from "./Paytype.vue?vue&type=template&id=56cba3fc"
import script from "./Paytype.vue?vue&type=script&lang=js"
export * from "./Paytype.vue?vue&type=script&lang=js"
import style0 from "./Paytype.vue?vue&type=style&index=0&id=56cba3fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports